import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";

/**
 * 获取电量信息 - 异步
 * @returns object
 */
export var getBattery = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var t;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            t = {
              level: -1,
              charging: -1
            };

            try {
              navigator.getBattery().then(function (e) {
                ;
                t.level = e.level, t.charging = e.charging ? 1 : 0;
              });
            } catch (t) {}

            return _context.abrupt("return", t);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getBattery() {
    return _ref.apply(this, arguments);
  };
}();